// The app itself: moving between pages, memory, skills. Always on
import type { AssistantModule, ToolPolicy } from "@/lib/assistant/types"
import { makeAppTools, type AppModuleContext } from "./tools"

export { navigablePages, type AppPage, type AppModuleContext } from "./tools"

const policies: Record<string, ToolPolicy> = {
  app_navigate: { kind: "read" },
  app_context: { kind: "read" },
  memory_search: { kind: "read" },
  skill_use: { kind: "read" },
  // Only asks; the user's answer is the approval
  ask_user: { kind: "read" },
  // The agent's own notes; logged, but not worth an approval prompt
  memory_save: { kind: "write", selfReviewed: true },
  memory_forget: { kind: "write", selfReviewed: true },
}

const labels = {
  app_navigate: "Open page",
  app_context: "Check current page",
  memory_save: "Remember",
  memory_forget: "Forget",
  memory_search: "Search past chats",
  skill_use: "Use skill",
  ask_user: "Question for you",
}

export function makeAppModule(ctx: AppModuleContext): AssistantModule {
  return { id: "app", title: "App", tools: makeAppTools(ctx), policies, labels }
}
